import { NOTIFICACIONS_LOAD, NOTIFICACIONS_SUCCESS, NOTIFICACIONS_FAIL,
UPDATE_NOTIFICACIONS_LOAD, UPDATE_NOTIFICACIONS_SUCCESS, UPDATE_NOTIFICACIONS_FAIL, COUNT_NOTIFICACIONS_LOAD, COUNT_NOTIFICACIONS_SUCCESS, COUNT_NOTIFICACIONS_FAIL, NOTIFICACIONS_DEFAULT_IMAGE_LOAD, NOTIFICACIONS_DEFAULT_IMAGE_SUCCESS, NOTIFICACIONS_DEFAULT_IMAGE_FAIL } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
  updateData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NOTIFICACIONS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case NOTIFICACIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case NOTIFICACIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case UPDATE_NOTIFICACIONS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_NOTIFICACIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        updateData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case UPDATE_NOTIFICACIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };


    case COUNT_NOTIFICACIONS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case COUNT_NOTIFICACIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        countData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case COUNT_NOTIFICACIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

      case NOTIFICACIONS_DEFAULT_IMAGE_LOAD:
      return {
        ...state,
        loading: true,
      };
    case NOTIFICACIONS_DEFAULT_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        defaultImage: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case NOTIFICACIONS_DEFAULT_IMAGE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };


    default:
      return state;
  }
}
